export default function timeline() {
    if (document.querySelector(".timeline")) {
        // SCROLL COM GRAB
        const scrollArea = document.querySelector(".timeline");
        let isMouseDown = false;
        let startX, scrollLeft;

        // Quando o mouse é pressionado, registramos a posição inicial
        scrollArea.addEventListener("mousedown", (e) => {
            isMouseDown = true;
            startX = e.pageX - scrollArea.offsetLeft;
            scrollLeft = scrollArea.scrollLeft;
            scrollArea.style.cursor = "grabbing"; // Mudamos o cursor para "grabbing"
        });

        // Quando o mouse é movido, movemos o conteúdo se o botão estiver pressionado
        scrollArea.addEventListener("mousemove", (e) => {
            if (!isMouseDown) return; // Se o botão do mouse não estiver pressionado, não faz nada
            const x = e.pageX - scrollArea.offsetLeft;
            const walk = (x - startX) * 2; // Multiplicando por 2 para aumentar a velocidade do movimento
            scrollArea.scrollLeft = scrollLeft - walk;
        });

        // Quando o mouse é liberado, paramos o movimento
        scrollArea.addEventListener("mouseup", () => {
            isMouseDown = false;
            scrollArea.style.cursor = "grab"; // Retornamos ao cursor "grab"
        });

        // Quando o mouse sai da área, também paramos o movimento
        scrollArea.addEventListener("mouseleave", () => {
            isMouseDown = false;
            scrollArea.style.cursor = "grab";
        });
    }
}
